module.exports = __webpack_public_path__ + "img/upperCaseD.62582b5e.svg";